import { ChevronRight } from "lucide-react";

import { cn } from "@/lib/utils";
// @ts-ignore
import worksIcon from "../../../../assets/ilustraciones/objetos/obras.svg";
// @ts-ignore
import goodsIcon from "../../../../assets/ilustraciones/objetos/bienes.svg";
// @ts-ignore
import servicesIcon from "../../../../assets/ilustraciones/objetos/servicios.svg";
// @ts-ignore
import consultingIcon from "../../../../assets/ilustraciones/objetos/consultoria.svg";
import { ActionBar, Eyebrow, ScreenLead, ScreenTitle } from "../OnboardingShell";
import { SALE_SUBJECTS, type SaleSubject } from "./contractorLine";

const ORDER: SaleSubject[] = ["works", "goods", "services", "consulting"];

// Íconos animados (la animación vive dentro del SVG) sobre el tono de cada objeto.
const ICONS: Record<SaleSubject, { src: string; tileClass: string }> = {
  works: { src: worksIcon, tileClass: "bg-blue-50" },
  goods: { src: goodsIcon, tileClass: "bg-amber-50" },
  services: { src: servicesIcon, tileClass: "bg-emerald-50" },
  consulting: { src: consultingIcon, tileClass: "bg-violet-50" },
};

/**
 * Antes de las preguntas: qué le vende al Estado. Decide dónde se buscan sus
 * términos, si hay tamaño (solo obras) y cruce con documentos (no en bienes). Elegir avanza.
 */
export function SubjectStep({
  onSelect,
  onBack,
}: {
  onSelect: (subject: SaleSubject) => void;
  onBack: () => void;
}) {
  return (
    <div className="mx-auto w-full max-w-[620px]">
      <Eyebrow tone="blue">Le vendo al Estado</Eyebrow>
      <ScreenTitle>¿Qué le vendes al Estado?</ScreenTitle>
      <ScreenLead>Elige lo principal. Si haces más de una cosa, luego creas otra línea.</ScreenLead>

      <div className="mt-6 flex flex-col gap-2.5">
        {ORDER.map((subject) => (
          <button
            key={subject}
            type="button"
            onClick={() => onSelect(subject)}
            className="flex cursor-pointer items-center gap-4 rounded-[16px] border-2 border-slate-200 bg-white px-3 py-3 text-left transition-colors hover:border-blue-700 hover:bg-blue-50/60"
          >
            <span
              className={cn(
                "flex size-14 shrink-0 items-center justify-center rounded-[14px]",
                ICONS[subject].tileClass,
              )}
            >
              <img src={ICONS[subject].src} alt="" className="size-11" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-[16px] font-bold text-slate-900">
                {SALE_SUBJECTS[subject].label}
              </span>
              <span className="block text-[13px] text-slate-500">
                {SALE_SUBJECTS[subject].detail}
              </span>
            </span>
            <ChevronRight className="size-5 shrink-0 text-slate-400" />
          </button>
        ))}
      </div>

      <ActionBar onBack={onBack} />
    </div>
  );
}
